//import jQuery from 'jquery'
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
//import CustomAnimation from '../animation/customAnimation';
import jQuery from "jquery";

//const customAnmation = new CustomAnimation();

var getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split('&'),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split('=');

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined ? true : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};

class Resources {
  init() {
    this.initPage();
    this.initParallax();
  }

  initPage = () => {
    jQuery('.header_background').css("background-image", "url("+ jQuery('.header_background').data('bg-image') +")");
    var searchParam = getUrlParameter('search');
    if(searchParam == "" || searchParam == false) {
      jQuery('.search_result').addClass('hide');
    }
    else  {
      jQuery('.search_result').removeClass('hide');
      $('html, body').scrollTop($("#business_boost").offset().top);
    }
  }

  initParallax = () => {
    gsap.registerPlugin(ScrollTrigger);
  }
}

export default Resources;
